import { FC } from 'react';
import { Container } from './Firmness-Card.styles';
import { FirmnessCardType } from '@sleepunique/types/firmness-card-type';
import { Icon, Typography } from '@sleepunique/components/atoms';

const FirmnessCard: FC<FirmnessCardType> = ({ isDual, title, icon, text }: FirmnessCardType) => (
  <Container className="firmess-card" isDual={isDual}>
    <Typography className="firmness-card__title" tag="h4" text={title!} />
    <Typography className="firmness-card__description" tag="p" text={text!} />
    {icon && <Icon className="firmness-card__icon" icon={icon} size="xxl" color="#e3f2f5" />}
  </Container>
);

export default FirmnessCard;
